module.exports = __webpack_public_path__ + "static/media/nerd.5f5d9052.svg";